import { useTranslation } from '../i18n';

export default function AccessBanner() {
  const { dict } = useTranslation();
  return (
    <div className="access-banner">
      <div className="access-banner-title">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7.5" cy="7.5" r="6" stroke="#1B2A9E" strokeWidth="1.4" fill="none" />
          <path d="M7.5 4.5v3.5l2 1" stroke="#1B2A9E" strokeWidth="1.4" strokeLinecap="round" fill="none" />
        </svg>
        <span>{dict.access_title}</span>
      </div>
      <div className="access-opts">
        <div className="access-opt access-opt--a">
          <div className="access-opt-icon">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M2 9h14M9 2v14" stroke="var(--col-a)" strokeWidth="1.8" strokeLinecap="round"/>
              <circle cx="9" cy="9" r="7.5" stroke="var(--col-a)" strokeWidth="1.4" fill="none"/>
            </svg>
          </div>
          <div className="access-opt-body">
            <div className="access-opt-label">{dict.access_path_a_label}</div>
            <div className="access-opt-desc">{dict.access_path_a_desc}</div>
          </div>
          <div className="access-opt-badge access-opt-badge--a">{dict.access_path_a_badge}</div>
        </div>
        <div className="access-opt-divider">
          <span className="access-or">{dict.access_or}</span>
        </div>
        <div className="access-opt access-opt--b">
          <div className="access-opt-icon">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <rect x="2" y="4" width="14" height="10" rx="2" stroke="var(--col-b)" strokeWidth="1.4" fill="none"/>
              <path d="M6 9h6M9 6.5v5" stroke="var(--col-b)" strokeWidth="1.6" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="access-opt-body">
            <div className="access-opt-label">{dict.access_path_b_label}</div>
            <div className="access-opt-desc">{dict.access_path_b_desc}</div>
          </div>
          <div className="access-opt-badge access-opt-badge--b">{dict.access_path_b_badge}</div>
        </div>
      </div>
      <div className="access-banner-note">{dict.access_note}</div>
    </div>
  );
}
